package com.exura.components.dialogs

import androidx.compose.runtime.Composable
import com.exura.components.buttons.AppButton
import com.exura.components.buttons.ButtonDangerVariant
import com.exura.components.buttons.ButtonGhostVariant
import com.exura.components.buttons.ButtonKind
import com.exura.components.icons.UntiledIcon
import com.exura.components.pageTypography.ExuraBodySizeTextVariant
import com.exura.components.pageTypography.ExuraSectionHeaderTextVariant
import com.exura.components.pageTypography.ExuraTextStyle
import com.exura.features.localization.commonLocalization
import com.exura.ui.Assets
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.JustifyContent

@Composable
fun YesNoDialog(
    title: String = commonLocalization.current.controls.areYouSure,
    body: String? = null,
    confirmButtonVariant: CssStyleVariant<ButtonKind>? = ButtonDangerVariant,
    confirmText: String = commonLocalization.current.controls.yes,
    dismissText: String = commonLocalization.current.controls.no,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit,
) {
    Column(
        verticalArrangement = Arrangement.spacedBy(Dimens.dialogContentGap),
    ) {
        SpanText(
            text = title,
            modifier = ExuraTextStyle.toModifier(ExuraSectionHeaderTextVariant),
        )

        if (body != null) {
            SpanText(
                text = body,
                modifier = ExuraTextStyle.toModifier(ExuraBodySizeTextVariant)
            )
        }

        Row(
            horizontalArrangement = Arrangement.spacedBy(Dimens.dialogControlsGap),
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxWidth()
                .justifyContent(JustifyContent.Center)
        ) {
            AppButton(
                text = dismissText,
                onClick = onDismiss,
                variant = ButtonGhostVariant,
                icon = { UntiledIcon(Assets.IconsUntiled.CROSS_MARK) }
            )
            AppButton(
                text = confirmText,
                onClick = onConfirm,
                variant = confirmButtonVariant,
                icon = { UntiledIcon(Assets.IconsUntiled.CHECK_MARK) }
            )
        }
    }
}
